<template>
  <div class="page-container">
    <el-breadcrumb separator="/">
      <el-breadcrumb-item>
        <span class="page-title">审批</span>
      </el-breadcrumb-item>
      <el-breadcrumb-item>C2C全量订单</el-breadcrumb-item>
    </el-breadcrumb>
    <el-card class="page-content" shadow="never">
      <div class="page-actions">
        <el-input
          placeholder="请输入商家用户ID"
          clearable
          v-model="merchantUserId"
        >
        </el-input>
        <el-input placeholder="请输入用户ID" clearable v-model="userId">
        </el-input>
        <el-input placeholder="请输入订单ID" clearable v-model="id"> </el-input>
        <el-select v-model="status" placeholder="请选择订单状态">
          <el-option value="">请选择</el-option>
          <el-option
            v-for="(type, key) in statusTypes"
            :key="key"
            :label="type.text"
            :value="key"
          ></el-option>
        </el-select>
        <el-select v-model="direction" placeholder="请选择订单方向">
          <el-option value="">请选择</el-option>
          <el-option
            v-for="item in derection"
            :key="item.value"
            :label="item.label"
            :value="item.value"
          ></el-option>
        </el-select>
        <el-date-picker
          type="datetimerange"
          v-model="times"
          value-format="yyyy-MM-dd HH:mm:ss"
          range-separator="至"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
        >
        </el-date-picker>
        <el-button @click="handleSearch" type="primary">搜索</el-button>
        <a :href="downloadLink" target="_blank">导出Excel</a>
      </div>
      <audit-list @refresh="getList"></audit-list>
    </el-card>
  </div>
</template>

<script>
import './store';
import AuditList from './components/list';
import { mapState, mapMutations, mapActions } from 'vuex';
import { STATUS_TYPE } from './constants.js';
import qs from 'qs';

export default {
  name: 'MerchantAudit',
  data() {
    return {
      times: [],
      userId: '',
      merchantUserId: '',
      statusTypes: STATUS_TYPE,
      status: '',
      id: '',
      direction: '',
      derection: [
        { value: 'ASK', label: '卖单' },
        { value: 'BID', label: '买单' }
      ]
    };
  },
  components: {
    AuditList
  },
  computed: {
    ...mapState('c2call', ['activeTab', 'pagination']),
    startTime() {
      return this.times ? this.times[0] : '';
    },
    endTime() {
      return this.times ? this.times[1] : '';
    },
    downloadLink() {
      const data = {
        startTime: this.startTime,
        endTime: this.endTime,
        status: this.status,
        userId: this.userId,
        id: this.id,
        direction: this.direction,
        merchantUserId: this.merchantUserId,
        ...this.pagination,
        excel: 1
      };
      const params = qs.stringify(data);
      return `/la/admin/c2c/order/all?${params}`;
    }
  },
  methods: {
    ...mapActions('c2call', ['getAllList']),
    getList(data = {}) {
      this.getAllList({
        startTime: this.startTime,
        endTime: this.endTime,
        status: this.status,
        userId: this.userId,
        id: this.id,
        direction: this.direction,
        merchantUserId: this.merchantUserId,
        ...this.pagination,
        ...data
      });
    },
    handleSearch() {
      this.getList({
        page: 1
      });
    }
  },
  created() {
    this.getList({
      page: 1
    });
  }
};
</script>

<style lang="less">
.user-withdrawal-link {
  color: #409eff;
  .cell {
    span {
      &:hover {
        text-decoration: underline;
      }
    }
  }
}
.user-withdrawal-records-wrap {
  .el-table {
    .cell {
      font-size: 12px;
      text-align: center;
    }
  }
  .user-withdrawal-pager-wrap {
    text-align: right;
    margin: 10px 0px;
  }
}
</style>
